import React from 'react';
import { semanas } from '../data/oferta';
export function SemanasSection() {
  return <section aria-labelledby="semanas-titulo" className="border-b border-violet-line/40 bg-violet-deep" data-id="element-104" data-mp="iiz1uvjqv908">
      <div className="mx-auto max-w-5xl px-6 py-20 sm:py-24 lg:px-8" data-id="element-105" data-mp="4svjifnzjzg2">
        <h2 id="semanas-titulo" className="max-w-2xl font-serif text-3xl font-medium leading-tight text-bone sm:text-4xl" data-id="element-106" data-mp="8t5yghtra072">
          Un recorrido de 5 semanas, una por cada nivel de consciencia
        </h2>

        <ol className="mt-14 space-y-0" data-id="element-107" data-mp="11gth3rbgugr2">
          {semanas.map((semana, i) => <li key={semana.numero} className="relative grid grid-cols-[3rem_1fr] gap-x-6 pb-10 sm:grid-cols-[4.5rem_1fr] sm:gap-x-10" data-id="element-108" data-mp="nj4twctxexiu" data-mpi={i}>
              {i !== semanas.length - 1 && <span aria-hidden="true" className="absolute left-[1.45rem] top-12 h-[calc(100%-2rem)] w-px bg-violet-line sm:left-[2.2rem]" data-id="element-109" data-mp="386znfafg4p6x" />}
              <span className="relative flex h-12 w-12 items-center justify-center rounded-full border border-gold/50 bg-violet font-serif text-xl text-gold sm:h-[4.5rem] sm:w-[4.5rem] sm:text-2xl" data-id="element-110" data-mp="2oklne4cgs254">
                {semana.numero}
              </span>
              <div className="pt-2 sm:pt-6" data-id="element-111" data-mp="2tiwyeiehwiox">
                <p className="font-sans text-[0.7rem] font-medium uppercase tracking-[0.24em] text-gold/70" data-id="element-112" data-mp="2ti53l9sq2ozp">
                  Semana {semana.numero}
                </p>
                <h3 className="mt-2 font-serif text-2xl font-medium text-bone sm:text-3xl" data-id="element-113" data-mp="32j3abzujpalz">
                  {semana.titulo}
                </h3>
                <p className="mt-3 max-w-xl font-sans text-base font-light leading-relaxed text-bone/70" data-id="element-114" data-mp="3havd7cd5kw6t">
                  {semana.descripcion}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}